export default __webpack_public_path__ + "static/media/adepeju.c109d51b.jpg";